import { Outlet } from 'react-router-dom'

/**
 * Layout minimal (plein écran) sans menu/header.
 * Utilisé pour les vues type POS.
 */
const LayoutSimple = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <Outlet />
    </div>
  )
}

export default LayoutSimple




